export default "__VITE_ASSET__Da$SHzap__"